import { render, staticRenderFns } from "./GameUiComponentFixed.vue?vue&type=template&id=4d93d0ce&scoped=true&"
import script from "./GameUiComponentFixed.vue?vue&type=script&lang=js&"
export * from "./GameUiComponentFixed.vue?vue&type=script&lang=js&"
import style0 from "./GameUiComponentFixed.vue?vue&type=style&index=0&id=4d93d0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d93d0ce",
  null
  
)

export default component.exports